function CartSamplesRemoveClick(event)
{
  //console.log('CartSamplesRemoveClick ' + event.classList);
  event.classList.add("loading");
  event.querySelector(".loading-overlay__spinner").classList.remove('hidden');
  event.setAttribute("aria-disabled", "true");
}

function CartSampleRemoveItem(lineItemKey)
{
  const xhr = new XMLHttpRequest();
  xhr.open("POST", "/cart/change.js", false);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.send(JSON.stringify({ id: lineItemKey, quantity: 0 }));
  //console.log("CartSampleRemoveItem()");

  //console.log(xhr.responseText);
}

function CartSamplesAddClick(trigger)
{

  const elements = document.querySelectorAll('.cart-items-samples-block-items .quick-add button');
  //elements.forEach(el => { if (el !== trigger) el.disabled = true; });
  setTimeout(() => {
    elements.forEach(el => { el.disabled = true; });
    setTimeout(() => elements.forEach(el => el.disabled = false), 5000);
  });
}

function CartSamplesCheckShouldExpand()
{

  CartSamplesExpandCollapseListen();


  return;
  
  if(CartSamplesExpandCollapseState != "none")
  {
    if(CartSamplesExpandCollapseState == "false")
    {
      CartSamplesForceHide();
      return;
    }
    else
    {
      CartSamplesForceShow();
      return;
    }
  }
  

  const width = window.innerWidth;
  console.log(width);
  if(width < 600 )
  {
    return;
  }


  CartSamplesForceHide();
    
}

function CartSamplesForceHide()
{
  console.log('CartSamplesForceHide');

  const el = document.getElementById("cart-items-sample-block-main");
  el.classList.remove("show");

  
  var myCollapse = document.getElementById('cart-items-sample-block-main');
  var bsCollapse = new bootstrap.Collapse(myCollapse, {
    toggle: false
  });
}

function CartSamplesForceShow()
{
  console.log('CartSamplesForceShow');
  const el = document.getElementById("cart-items-sample-block-main");
  el.classList.add("show");

  /*
  var myCollapse = document.getElementById('cart-items-sample-block-main');
  var bsCollapse = new bootstrap.Collapse(myCollapse, {
    toggle: true
  });
  */
}


var CartSamplesExpandCollapseState = "none";
function CartSamplesExpandCollapseListen()
{

  const sampleHeaderButtonToggle = document.querySelector('button.cart-items-samples-block-header-text');

  if(sampleHeaderButtonToggle == null)
  {
    //console.log("sampleHeaderButtonToggle is null");
    return;
  }

  
  sampleHeaderButtonToggle.addEventListener("click", function(event) {
    const expandStateAria = sampleHeaderButtonToggle.getAttribute('aria-expanded');
    //console.log('sampleHeaderButtonToggle click detected');  
    //console.log('expandStateAria = ' + expandStateAria);
    CartSamplesExpandCollapseState = expandStateAria;
  });
}

const samplesRemoveItemTarget = ".cart-items-samples-block .cart-item-title-remove .button";

document.addEventListener("click", function(event) {
    if (event.target.matches(samplesRemoveItemTarget)) {
      CartSamplesRemoveClick(event.target);
    }
});



document.addEventListener("keydown", function(event) {
    if (event.key === "Enter" && event.target.matches(samplesRemoveItemTarget)) {
        CartSamplesRemoveClick(event.target);
    }
});

document.addEventListener("DOMContentLoaded", function() {
    CartSamplesCheckShouldExpand();
    
});







var cartAutoAddExistCount;

async function CartAutoSamplesUpdate()
{

  cartAutoAddExistCount = 0;
  //console.log('CartAutoSamplesUpdate Start');
  
  if(!cartAutoSamplesUpdateEnabled)
  {
    //console.log('CartAutoSamplesUpdate Disabled');
    return;
  }
  //console.log('cartAutoSamplesData as follows:');
  //console.log(cartAutoSamplesData);
  //console.log('CartAutoSamplesUpdate Run');
  //check if bonus available for cart contents

  
  CartRunAutoSampleLogic().then(data => {
      CartAutoSampleRefreshCart();
  });
  

}


var CartAutoSampleRefreshCartStarted = false;
function CartAutoSampleRefreshCart()
{

  CartAutoSampleRefreshCartStarted = true;
  console.log('CartAutoSampleRefreshCart Running');
  
  const currentUrl = window.location.href;
  if(currentUrl.includes("/cart"))
  {
      RefreshCartData();
  }
  else
  {
    refreshFlyOutCartContents();
  }
}

async function CartRunAutoSampleLogic()
{
  
  var cartData = await CartAutoGetCartContents();

  CartAutoCheckTotalInCart(cartData, cartAutoSamplesData);
  CartRunPurgeBadItemsLogic(cartData);
  
  //console.log('CartAutoGetCartContents Cart Contents follows');
  //console.log(cartData);
  //cartAutoSamplesData this comes from the settings file while loads a simple array of auto add free sample items


  
  
  for (let nextAutoItem of cartAutoSamplesData) 
  {
    //console.log('next sample data in array follows:');
    //console.log(nextAutoItem);


    var conditionMet = CartAutoCheckConditionMet(cartData, nextAutoItem);
    //console.log('conditionMet = ' + conditionMet);
    if(conditionMet)
    {
      cartAutoAddExistCount++;
      await CartAutoAddToCart(nextAutoItem.id,1);

    }

  }
  
}

function CartRunPurgeBadItemsLogic(cartData)
{
  //console.log('Running CartRunPurgeBadItemsLogic');
  //console.log('samples_cart_total_threshold_for_offers = ' + samples_cart_total_threshold_for_offers);

  for(let nextSampleItem of cartSampleVariantData)
  {
    for (let nextCartItem of cartData.items) 
    {

      //console.log('nextSampleItem.id:' +nextSampleItem.id+ ' | nextCartItem.variant_id = ' + nextCartItem.variant_id);
      
      if(nextSampleItem.id == nextCartItem.variant_id)
      {
          var thresholdMet = CartCheckSampleThresholdMet(cartData);
          //console.log('delete check thresholdMet to keep = ' + thresholdMet);
          if(!thresholdMet)
          {
            CartSampleRemoveItem(nextCartItem.key);
            var autoAddName = "sampleAutoAdd" + nextCartItem.variant_id;
            //console.log('CartAutoAddRemoveCookie id = ' + autoAddName);
            CartSamplesSysRemoveCookie(autoAddName);
          }
      }
    }
  }
  
}

async function CartAutoGetCartContents()
{
    try {
        const response = await fetch('/cart.js', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        return response.json();
    } catch (error) {
        console.error('Error Getting Cart:', error);
    }
}

function CartAutoCheckTotalInCart(cartData, cartAutoSamplesData)
{
  for(let nextAutoItem of cartAutoSamplesData)
  {
    for (let nextCartItem of cartData.items) 
    {
      if(nextAutoItem.id == nextCartItem.variant_id)
      {
        cartAutoAddExistCount++;
        return false;
      }
    }
  }
}

function CartCheckSampleThresholdMet(cartData)
{
  
  if(cartData.items_subtotal_price == 0 || cartData.items_subtotal_price/100 < samples_cart_total_threshold_for_offers)
  {
    console.log('cart total threshold not met');
    return false;
  }

  return true;
}

function CartAutoCheckConditionMet(cartData, nextAutoItem)
{
  console.log('CartAutoCheckConditionMet Cart Contents follows');
  console.log(cartData);

  var autoAddName = "sampleAutoAdd" + nextAutoItem.id;

  var cookieAutoCheck = CartSamplesSysGetCookie(autoAddName);
  console.log('cookieAutoCheck output follows for ('+autoAddName+'):');
  console.log(cookieAutoCheck);

  if(samples_max_offer_claims > 0 && cartAutoAddExistCount >= samples_max_offer_claims)
  {
    console.log('claims max met');
    return false;
  }

  if(samples_cart_total_threshold_for_offers > 0 && cartData.items_subtotal_price/100 < samples_cart_total_threshold_for_offers)
  {
    console.log('cart total threshold not met');
    return false;
  }

  if(cookieAutoCheck != null)
    return false;

  for (let nextCartItem of cartData.items) 
  {
    if(nextAutoItem.id == nextCartItem.variant_id)
    {
      cartAutoAddExistCount++;
      return false;
    }
  }
  
  if(nextAutoItem.conditionalVeriants != null && nextAutoItem.conditionalVeriants.length > 0)
  {
    for (let conditionalId of nextAutoItem.conditionalVariants) 
    {
      for (let nextCartItem of cartData.items) 
      {
        if(conditionalId == nextCartItem.variant_id)
          return true;
      }
    }
    return false;
  }

  return true;
}

async function CartAutoAddToCart(variantId, quantity = 1) {
    try {
      const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity })
      });
      var responseData = await response.json();
      var autoAddName = "sampleAutoAdd" + variantId;
      console.log('autoAddName = ' + autoAddName);
      CartSamplesSysSetCookie(autoAddName,autoAddName,1);
      return responseData;
    } catch (error) {
        console.error('Error Adding to Cart:', error);
    }
}


function CartSamplesSysSetCookie(name, value, days) {
  const expires = new Date(Date.now() + (days*24*60*60*1000)).toUTCString();
  document.cookie = `${name}=${value}; expires=${new Date(expires).toUTCString()}; path=/`;
}

function CartSamplesSysGetCookie(name) {
  const matches = document.cookie.match(new RegExp(
    '(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

function CartSamplesSysRemoveCookie(name) {
  document.cookie = name + '=; Max-Age=0; path=/';
}